// extracted by mini-css-extract-plugin
module.exports = {"notify":"notify_notify__bylWh"};